import React, { FC } from "react";
import Drawer from "@mui/material/Drawer";
import { IModalTypes } from "./IModal";

const MobileModal: FC<IModalTypes.MobileModalProps> = ({
    anchor = "bottom",
    children,
    open,
    onClose,
    ...rest
}) => {
    return (
        <Drawer anchor={anchor} open={open} onClose={onClose} {...rest}>
            {children}
        </Drawer>
    );
};

export default MobileModal;
